import CrudCustom from '../../../libs/custom/CrudCustom';

let PerhitunganPPh21LainnyaService = new CrudCustom('/perhitungan-pph21-lainnyas');
export default PerhitunganPPh21LainnyaService;
